<template>
  <div class="sidebar">
    <div class="sidebar-menu">
      <router-link
        v-for="menu in menuConfig"
        :key="menu.name"
        :to="menu.path"
        :class="['menu-item', { active: currentRoute === menu.path }]"
      >
        <i :class="menu.icon"></i>
        <span>{{ menu.label }}</span>
      </router-link>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useRoute } from 'vue-router'
import menuConfig from '@/utils/menuConfig.js'

const route = useRoute()

// 计算当前路由，用于高亮显示当前菜单项
const currentRoute = computed(() => {
  return route.path
})
</script>

<style scoped>
.sidebar {
  width: 200px;
  background-color: #304156;
  color: #fff;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  transition: all 0.3s ease;
  overflow-y: auto;
}

.sidebar-menu {
  padding: 20px 0;
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 12px 20px;
  color: rgba(255, 255, 255, 0.7);
  text-decoration: none;
  transition: all 0.3s ease;
  cursor: pointer;
}

.menu-item:hover {
  background-color: #1f2d3d;
  color: #fff;
}

.menu-item.active {
  background-color: #1f2d3d;
  color: #fff;
  border-right: 3px solid var(--primary-color);
}

.menu-item i {
  margin-right: 10px;
  font-size: 16px;
}

.menu-item span {
  font-size: 14px;
}

/* 响应式样式 */
@media (max-width: 1200px) {
  .sidebar {
    width: 60px;
  }
  
  .sidebar-menu {
    padding: 20px 0;
  }
  
  .menu-item span {
    display: none;
  }
}

@media (max-width: 768px) {
  .sidebar {
    width: 60px; /* 保持固定宽度 */
    height: 100vh; /* 保持全屏高度 */
    position: fixed; /* 保持固定定位 */
  }
  
  .sidebar-menu {
    padding: 20px 0;
    display: block;
  }
  
  .menu-item {
    flex: none;
    justify-content: center;
    padding: 15px 0;
  }
  
  .menu-item i {
    margin-right: 0;
  }
  
  .menu-item span {
    display: none;
  }
}
</style>